const getters = {
  userInfo: state => state.app.userInfo,
  isMobile: modules => modules.app.isMobile,
  publishStatus: state => state.app.publishStatus,
  userinfologin: state => state.app.userinfologin,
  timeDiff: state => state.app.timeDiff,
  shareTitle: state => state.app.shareTitle,
  operateCode: state => state.app.operateCode,
  shareList: state => state.app.shareList,
  operate: state => state.app.operate,
  infoList: state => state.app.infoList,
  fourList: state => state.app.fourList,
  ewmList: state => state.app.ewmList,
  youList: state => state.app.youList,
  uploadParams: state => state.app.uploadParams,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js